import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "font-italic font-weight-thin mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EditAdresseDialog = _resolveComponent("EditAdresseDialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", {
                        textContent: _toDisplayString(_ctx.$t('einstellungen.basis.title'))
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "pb-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "2",
                    class: "d-flex align-items-center text-nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.basis.teilnehmer')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.kundenDaten.firma), 1),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.kundenDaten.strasse + (_ctx.kundenDaten.hausNummer ? ' ' + _ctx.kundenDaten.hausNummer : '')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.kundenDaten.plz + ' ' + _ctx.kundenDaten.ort), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "py-0 text-nowrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.basis.teilnehmernummer')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.kundenDaten.teilnehmerStatus)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.kundenDaten.kundenNummer + ' (' + _ctx.$t('einstellungen.basis.active') + ' ' + _ctx.kundenDaten.ersteAktivierungAm + ')'), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.kundenDaten.kundenNummer + ' (' + _ctx.$t('einstellungen.basis.inaktiv') + ')'), 1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "py-0 text-nowrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.basis.telefon')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.kundenDaten.telefon), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "py-0 text-nowrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.basis.email')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.kundenDaten.email), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditAdresseDialog, {
                        "edit-teilnehmer": _ctx.kundenDaten,
                        onSuccess: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('success')))
                      }, null, 8, ["edit-teilnehmer"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      (_ctx.kundenDaten.istMutiertInVetdata)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode("mdi-information")
                              ])),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('einstellungen.basis.modifiziert')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}